import FormData from 'form-data';
export default FormData;



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/classes/FormData.js
// module id = 148
// module chunks = 0